'use client'
import type { ReactNode } from 'react'
import { cx } from '../utils'

export function PageHeader({
  eyebrow,
  title,
  description,
  actions,
}: {
  eyebrow?: string
  title: string
  description?: ReactNode
  actions?: ReactNode
}) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 pb-5">
      <div>
        {eyebrow && (
          <p className="font-mono text-[13px] tracking-[0.12em] text-ink-3 uppercase">{eyebrow}</p>
        )}
        <h1 className="mt-1 text-[22px] leading-tight font-semibold tracking-[-0.01em] text-ink">
          {title}
        </h1>
        {description && <p className="mt-1 max-w-xl text-[14.5px] text-ink-3">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  )
}
